module.exports = __webpack_public_path__ + "static/media/32-2.84ff08a3.mp3";